import { Button, Col } from "antd";
import { PlusOutlined } from "@ant-design/icons";

interface PlusButtonProps {
  onAdd: () => void;
}

export const PlusButton: React.FC<PlusButtonProps> = (props) => {
  const { onAdd } = props;

  return (
    <Col xs={4}>
      <div className="card-comparison" style={{ height: "350px" }}>
        <div
          style={{
            width: "100%",
            height: "100%",
            padding: "12px",
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <Button
            icon={<PlusOutlined style={{ fontSize: "32px" }} />}
            onClick={onAdd}
            style={{
              height: 96,
              width: 96,
              backgroundColor: "transparent",
              color: "#fff",
              border: 0,
            }}
          />
        </div>
      </div>
    </Col>
  );
};

export default PlusButton;
